import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

// Titlecloudcompute
function SimpleStorageVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'S3 (Simple Storage Serice) - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Simple Storage Service")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Tạo S3 Bucket</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">Bucket là một container chứa các object lưu trữ trong lưu trữ đám mây.</p>
                                <p class="typo-14">Là thư mục cấp cao nhất truy cập qua URL.</p>
                            </BoxText>
                            <br></br>
                            <BoxText  >
                                <p class="typo-14">- Tên Bucket : </p>
                                <p class="typo-14">- Khu vực &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </p>
                                <p class="typo-14">- Access Control (Kiểm soát truy cập) :</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>URL khi tải lên / tải xuống tệp</p></BoxTitle>

                            <BoxText  >
                                https://
                                <font color="red">Tên Bucket</font>.storage.
                                <font color="red">Khu vực</font>.vora.net/
                                <font color="red">Directory Name</font>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Sơ đồ cấu hình tải lên Object vào Object Storage S3</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">Trước khi tải object (file, metadata) vào S3 Bucket, yêu cầu Pre-signed URL từ API của hệ thống lưu trữ, sau đó upload trực tiếp qua Pre-signed URL đã nhận.</p>
                            </BoxText>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-1.svg")} */}
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/simple-storage-service-1.png"></ImageWrap>

                            <BoxText  >
                                <p class="typo-14"><b>Single request upload</b></p>
                                <p class="typo-14">- Tải file khoảng 30MB trong một lần yêu cầu.</p>
                                <br></br>
                                <p class="typo-14"><b>Multipart upload</b></p>
                                <p class="typo-14">- Chia file thành ít nhất 3 phần trở lên và tải từng phần, tổng thể qua một yêu cầu.</p>
                                <p class="typo-14">- Tăng tốc quá trình tải bằng cách tải các phần nhỏ này song song.</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Sơ đồ cấu hình tải xuống từ Object Storage</p></BoxTitle>

                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-2.svg")} */}
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/simple-storage-service-2.png"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Quản lý object trong Bucket qua giao diện web</p></BoxTitle>
                            <BoxText  >
                                <p class="typo-14">- Object là các file và metadata được lưu trữ trong hệ thống.</p>
                                <p class="typo-14">- Lấy danh sách objects trong bucket, thao tác chỉ được phép dựa trên quyền trong IAM ACL.</p>
                            </BoxText>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-3.svg")} */}
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/simple-storage-service-3.png"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Đăng ký resource trong IAM để cấp quyền truy cập</p></BoxTitle>

                            <BoxText  ><p class="typo-14">- Cấu trúc phân cấp (Hierarchy) Parent / Child.</p></BoxText>
                            <BoxText  >
                                <p class="typo-14">- Quyền cha mẹ làm mặt định, riêng các thư mục con hoặc object có thể đặt quyền riêng.</p>
                            </BoxText>
                            <BoxText  ><p class="typo-14">- Quyền: Đọc / Ghi / Xóa</p></BoxText>
                            <BoxText  ><p class="typo-14">• Bucket</p></BoxText>
                            <BoxSubText  ><p class="typo-14">• Directory</p></BoxSubText>
                            <BoxSubTextSub  ><p class="typo-14">• Object(File, Metadata)</p></BoxSubTextSub>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Mô hình tải file lên/ xuống từ server truyền thống</p></BoxTitle>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-4.svg")} */}
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/simple-storage-service-4.png"></ImageWrap>
                        </BoxContent>

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};


const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const BoxSubText = styled.div`
  margin-left: 3%;
  line-height: 2em;
  
`
const BoxSubTextSub = styled.div`
  margin-left: 6%;
  line-height: 2em;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default SimpleStorageVN;